import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isUngatedForUnifiedStorefront"];
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { ThemeProvider, useTheme } from 'styled-components';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchBarInput(props) {
  const {
      isUngatedForUnifiedStorefront
    } = props,
    searchInputProps = _objectWithoutPropertiesLoose(props, _excluded);
  const theme = useTheme();

  // Memoize the conditional style props to prevent re-renders
  const unifiedStorefrontVariantProps = useMemo(() => {
    return isUngatedForUnifiedStorefront ? {
      borderStyle: 'solid',
      borderWidth: '100',
      borderColor: 'border-core-default',
      borderRadius: 'full',
      backgroundColor: 'fill-surface-default'
    } : {};
  }, [isUngatedForUnifiedStorefront]);
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/_jsx(TFlex, {
      align: "stretch",
      children: /*#__PURE__*/_jsx(SearchInput, Object.assign({}, searchInputProps, unifiedStorefrontVariantProps, {
        use: isUngatedForUnifiedStorefront ? 'default' : 'on-dark'
      }))
    })
  });
}